declare const newrelic: undefined | {
  noticeError(error: any): void;
};

export const noticeError = (error: any) => {
  if (typeof newrelic !== "undefined") {
    newrelic.noticeError(error);
  }
}
